import React, { useState } from 'react';
import './Data.scss';

// Warn, Success Info, Danger
function PrefixBadge({ prefixBadgeSeverity }) {
  switch (prefixBadgeSeverity) {
    case 'warn':
      return (
        <div className="badge-container bg-custom-orange">
          <i className="pi pi-exclamation-triangle " />
        </div>
      );
    case 'success':
      return (
        <div className="badge-container bg-custom-green">
          <i className="pi pi-check " />
        </div>
      );
    case 'danger':
      return (
        <div className="badge-container bg-custom-red">
          <i className="pi pi-times " />
        </div>
      );
    default:
      return (
        <div className="badge-container bg-primary">
          <i className="pi pi-exclamation-triangle " />
        </div>
      );
  }
}

function Data({ label, value, large, bgColor, suffix, prefixBadgeSeverity }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    setCopied(true);
    // Copy to clipboard
    await navigator.clipboard.writeText(value);
    setTimeout(() => {
      setCopied(false);
    }, 2500);
  };

  const formatValue = () => {
    if (!suffix) return value;
    return `${value} ${suffix}`;
  };

  return (
    <div
      onClick={handleCopy}
      className={`flex flex-col gap-y-1 cursor-pointer data-container ${
        large ? 'w-[340px]' : 'w-40'
      }`}>
      <div className="w-full flex flex-row justify-between items-center">
        <span className="text-slate-500 text-sm">{label}</span>
        <i
          className={`pi pi-copy copy-icon ${
            copied ? 'opacity-1 text-green-500' : 'opacity-0 text-slate-300'
          }`}
        />
      </div>
      <div className={`relative ${value ? '' : 'text-slate-400 italic font-extralight'}`}>
        <p className="overflow-hidden whitespace-nowrap text-ellipsis">
          <div className="flex flex-row items-center gap-2">
            {prefixBadgeSeverity && <PrefixBadge prefixBadgeSeverity={prefixBadgeSeverity} />}
            {value ? formatValue() : 'Non renseigné'}
          </div>
        </p>
        <p
          className={`absolute top-0 left-0 ${
            bgColor ? bgColor : 'bg-slate-50'
          } absolute-value-display whitespace-nowrap pr-2 z-20 data-content`}>
          <div className="flex flex-row items-center gap-2">
            {prefixBadgeSeverity && <PrefixBadge prefixBadgeSeverity={prefixBadgeSeverity} />}
            {value ? formatValue() : 'Non renseigné'}
          </div>
        </p>
      </div>
    </div>
  );
}

export default Data;
